'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoMarkdown = function GoMarkdown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.1 7.5h-34.2c-1.6 0-2.9 1.3-2.9 2.9v19.2c0 1.6 1.3 2.9 2.9 2.9h34.2c1.6 0 2.9-1.3 2.9-2.9v-19.2c0-1.6-1.3-2.9-2.9-2.9z m-14.6 20l-5 0v-7.5l-3.7 4.8-3.8-4.8v7.5h-5v-15h5l3.8 5 3.7-5 5 0v15z m7.5 1.2l-6.2-8.7h3.7v-7.5h5v7.5h3.8l-6.3 8.7z' })
        )
    );
};

exports.default = GoMarkdown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/markdown.js
// module id = 1728
// module chunks = 0